var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export default function buildSearchResponse(_a) {
    var currentPlan = _a.currentPlan, impressionId = _a.impressionId, results = _a.results, footerContent = _a.footerContent;
    var transformV2Quote = function (_a) {
        var quoteMonthlyCents = _a.quoteMonthlyCents, props = __rest(_a, ["quoteMonthlyCents"]);
        return (__assign({ quoteMonthlyCentsCost: quoteMonthlyCents }, props));
    };
    var _b = results.reduce(function (_a, current) {
        var ads = _a.ads, quotes = _a.quotes, lifeQuotes = _a.lifeQuotes, bundles = _a.bundles, agencyContent = _a.agencyContent;
        return ({
            ads: "adContent" in current
                ? __spreadArray(__spreadArray([], ads, true), [current.adContent], false) : "homeAdContent" in current
                ? __spreadArray(__spreadArray([], ads, true), [current.homeAdContent], false) : ads,
            quotes: "quoteContent" in current
                ? __spreadArray(__spreadArray([], quotes, true), [transformV2Quote(current.quoteContent)], false) : "homeQuoteContent" in current
                ? __spreadArray(__spreadArray([], quotes, true), [transformV2Quote(current.homeQuoteContent)], false) : quotes,
            lifeQuotes: "lifeQuoteContent" in current
                ? __spreadArray(__spreadArray([], lifeQuotes, true), [current.lifeQuoteContent], false) : lifeQuotes,
            bundles: "bundleContent" in current
                ? __spreadArray(__spreadArray([], bundles, true), [current.bundleContent], false) : bundles,
            agencyContent: "agencyContent" in current ? current.agencyContent : agencyContent,
        });
    }, {
        ads: [],
        quotes: [],
        lifeQuotes: [],
        bundles: [],
        agencyContent: undefined,
    }), ads = _b.ads, quotes = _b.quotes, lifeQuotes = _b.lifeQuotes, bundles = _b.bundles, agencyContent = _b.agencyContent;
    var mixedResults = results.map(function (result) { return ({
        adContent: "adContent" in result
            ? result.adContent
            : "homeAdContent" in result
                ? result.homeAdContent
                : undefined,
        quoteContent: "quoteContent" in result
            ? transformV2Quote(result.quoteContent)
            : "homeQuoteContent" in result
                ? transformV2Quote(result.homeQuoteContent)
                : undefined,
    }); });
    return {
        ads: ads,
        currentPlan: currentPlan,
        quotes: quotes,
        lifeQuotes: lifeQuotes,
        bundles: bundles,
        impressionId: impressionId,
        mixedResults: mixedResults,
        footerContent: footerContent,
        agencyContent: agencyContent,
    };
}
